import { Routes, Route, Outlet } from "react-router-dom";
import FaqContextProvider from "../context/FaqContextProvider";
import Faq from "../pages/Faq";

export default function FaqRoutes() {
  return (
    <>
      <FaqContextProvider>
        <Routes>
          <Route path="/" element={<Faq />} />
        </Routes>
        <Outlet />
      </FaqContextProvider>
    </>
  );
}
